import { selectedWebEnvironment } from "../config/firebase";

// The Scerv V2 gateway this website build may use, as in the app's
// app.config.js: the staging gateway for the Testing build, the production
// gateway for the production site (scerv.com, Karl 2026-10-29). Having a URL
// changes nothing by itself: a /dine page serves the engine only for a
// restaurant whose newEngine switch is on; every other restaurant keeps the
// V1 page exactly as before.
const V2_GATEWAY_URLS = {
	development: null,
	testing: "https://scerv-v2-gateway-xjzjcw5xwa-uc.a.run.app",
	production: "https://scerv-v2-gateway-606076519772.us-central1.run.app",
};

// A testing build may point at another gateway (a local one, say).
export const engineGatewayUrl = () =>
	(selectedWebEnvironment.key === "testing" && process.env.REACT_APP_V2_GATEWAY_URL) ||
	V2_GATEWAY_URLS[selectedWebEnvironment.key] ||
	null;

// The Stripe publishable key the engine's payment form may use, as the app's
// engineStripeKey: live only on the production site (scervmvp, where the
// gateway charges live), test everywhere else. Anything else: null, no form.
export const enginePublishableKey = (key, environment = selectedWebEnvironment) => {
	if (typeof key !== "string") return null;
	const live = environment?.key === "production" && environment?.firebaseConfig?.projectId === "scervmvp";
	return (live ? /^pk_live_[A-Za-z0-9]+$/ : /^pk_test_[A-Za-z0-9]+$/).test(key) ? key : null;
};
